
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';

/*XSRF Token Imports*/
import { InterceptorService } from './interceptor/interceptor.service';
import { SessionStorageService } from './services/session-storage.service';
import { PrerenderLayoutService } from './services/prerender-layout.service';
import { StoreService } from './services/store.service';
import { NotFoundComponent } from './responses/not-found/not-found.component';
import { GenericComponent } from './responses/generic/generic.component';
import { RedirectComponent } from './responses/redirect/redirect.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    MatSnackBarModule
  ],
  declarations: [NotFoundComponent, GenericComponent, RedirectComponent],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true }, // XSRF Token,
    SessionStorageService,
    StoreService,
    PrerenderLayoutService
  ]
})
export class CoreModule { }
